import {
    Component,
    OnInit,
    OnDestroy, Input
} from '@angular/core';
import {ShareDataService as ShareDataServiceGeneric} from "@signature-it/ngx-generic/services";
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {EntityService, EntityPageService} from "@signature-it/ngx-entity/services";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";

declare let _: any;

@Component({
    selector: 'entity-breadcrumbs',
    templateUrl: './entity-breadcrumbs.component.html',
    styleUrls: ['./entity-breadcrumbs.component.scss'],
    standalone: false
})
export class EntityBreadcrumbsComponentGeneric implements OnInit, OnDestroy {
    @Input() eType: string = null;
    elements: any = {};
    elementsArray: any = [];
    solrDoc: any = {};
    separator: string = GenericConfig.entityBreadcrumbSeparator || 'fa-angle-right';
    homeType: string = GenericConfig.entityBreadcrumbHomeType || 'text';
    currentURL:string = '';
    showEntityBreadcrumbs: boolean = true;
    subscriptionsList$: Array<Subscription> = [];
    breadcrumbsRes;
    navIndexBreadcrumbs;
    selectedNodeData;

    constructor(protected entityService: EntityService,
                protected router: Router,
                protected entityPageService: EntityPageService,
                protected shareDataGeneric: ShareDataServiceGeneric) {
        this.currentURL = window.location.protocol + '//' + window.location.host;
    }

    ngOnInit() {
        this.subscriptionsList$.push(this.entityPageService.updateMainEntity.subscribe(solrResponse => {
            this.solrDoc = solrResponse;
            if(solrResponse ) {
                this.getBreadcrumbs(solrResponse)
            }
        }));
        this.subscriptionsList$.push(this.entityPageService.updateSelectedNode.subscribe(() => {
            this.replaceBreadcrumbs();
        }));
    }

    ngOnDestroy() {
        this.subscriptionsList$.forEach(s => s.unsubscribe());
        this.shareDataGeneric.showBreadcrumbs$.next(true);
        this.shareDataGeneric.showCatalogueBreadcrumbs$.next(true);
    }

    getBreadcrumbs(doc){
        this.elements = {};
        let url = this.eType ? '/' + this.eType + decodeURIComponent(this.router.url.split('?')[0]) : decodeURIComponent(this.router.url.split('?')[0]);
        let params = {
            'url': url
        };
        this.entityService.getEntityBreadcrumbs(params)
            .subscribe(
                res => {

                    if(res && Object.keys(res).length) {
                        this.breadcrumbsRes = res;
                        this.replaceBreadcrumbs();
                    }else {
                        this.breadcrumbsRes = null;
                        this.setDefaultBreadcrumbs();
                    }
                },error => {
                    this.breadcrumbsRes = null;
                    this.setDefaultBreadcrumbs();
                })
    }

    replaceBreadcrumbs() {
        if(this.breadcrumbsRes) {
            this.showEntityBreadcrumbs = true;
            const regexp = /[%](.*?)[%]/g;
            let resStr = JSON.stringify(this.breadcrumbsRes)
            resStr = resStr.replace(regexp, ($1, $2) => {
                let val = Array.isArray(this.solrDoc[$2]) ? this.solrDoc[$2][0] : this.solrDoc[$2];
                return val.replace(/\"/g, '&quot;');
            })
            let res = JSON.parse(resStr);

            this.elements = {...{'home': '/'}, ...res};
            this.elementsArray = [{
                title: 'home',
                url: '/',
            }]

            _.forEach(res,  (value, key) => {
                if(key == '$nav-index$' ) {
                    this.elementsArray.push({
                        title: this.entityPageService.selectedNodeData?.['name'] || '',
                        url: this.entityPageService.selectedNodeData?.['url'] || value,
                    })
                } else if(key ==  '$nav-index-full$' && Array.isArray(this.entityPageService._navIndexBreadcrumbs)) {
                    this.entityPageService._navIndexBreadcrumbs.map( (item) => {
                        this.elementsArray.push({
                            title: item['name'],
                            url: item['url'],
                        })
                    })
                } else if(key ==  '$nav-index-full$' ) {
                    this.elementsArray.push({
                        title: '',
                        url: value,
                    })
                } else {
                    this.elementsArray.push({
                        title: key,
                        url: value,
                    })
                }
            })
            this.shareDataGeneric.showBreadcrumbs$.next(false);
            this.shareDataGeneric.showCatalogueBreadcrumbs$.next(false);
        }

    }

    setDefaultBreadcrumbs(){
        this.shareDataGeneric.showCatalogueBreadcrumbs$.next(true);
        if (this.eType) {
            this.showEntityBreadcrumbs = false;
        }
    }

    routeLink(url){
        let params = this.router.parseUrl(url).queryParams;
        this.router.navigate([url.split('?')[0]], {queryParams: params});
    }
}

